import { ResultData, ValidateResult } from "@nt-portal/common-sdk";
import {
    ConicalDataService,
    MunicipalityCategory,
    MunicipalityCategoryDataService
} from "@nt-portal/doc-agent-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";

export interface MunicipalityCategoryOptions extends ControllerOptions<MunicipalityCategory> {}

export const initMunicipalityCategory = (): MunicipalityCategory => createMunicipalityCategory({});

export const createMunicipalityCategory = (
    item: Partial<MunicipalityCategory>
): MunicipalityCategory => ({
    id: item.id ?? "",
    name: item.name ?? "",
    code: item.code ?? "",
    createdBy: item.createdBy ?? ""
});

export class ClientMunicipalityCategoryService extends BaseClientService implements DataController<MunicipalityCategory> {
    private _service: ConicalDataService<MunicipalityCategory>;

    constructor() {
        super();
        // The SDK declaration currently specifies Municipality instead of
        // MunicipalityCategory for this service's generic entity type.
        this._service = new MunicipalityCategoryDataService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        }) as unknown as ConicalDataService<MunicipalityCategory>;
    }

    public async get(options: MunicipalityCategoryOptions): Promise<ResultData<MunicipalityCategory>> {
        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);
    }

    public async getLookup(options: MunicipalityCategoryOptions): Promise<ResultData<MunicipalityCategory>> {
        return await this._service.get(this.buildLookupFetchParams(options), this.token, options.filter);
    }

    public async getById(options: MunicipalityCategoryOptions): Promise<MunicipalityCategory | null> {
        return options.id ? await this._service.getById(options.id, this.token) : null;
    }

    public async delete(options: MunicipalityCategoryOptions): Promise<void> {
        if (options.id) await this._service.delete(options.id, this.token);
    }

    public async update(options: MunicipalityCategoryOptions): Promise<MunicipalityCategory | MunicipalityCategory[] | null> {
        return options.item?.id
            ? await this._service.update(options.item.id, options.item, this.token)
            : null;
    }

    public async add(options: MunicipalityCategoryOptions): Promise<MunicipalityCategory | MunicipalityCategory[] | null> {
        return options.item ? await this._service.add(options.item, this.token) : null;
    }

    public async import(options: MunicipalityCategoryOptions): Promise<any> {
        if (options.file) return await this._service.import(this.token, options.file);
    }

    public async export(options: MunicipalityCategoryOptions): Promise<any> {
        return await this._service.export(this.token, options.filter);
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult | null> {
        return await this._service.validateName(name, this.token, id, "");
    }
}
